import { render, staticRenderFns } from "./QuanLyMatKhauNguoiDung.vue?vue&type=template&id=05ac10fc&"
import script from "./QuanLyMatKhauNguoiDung.vue?vue&type=script&lang=js&"
export * from "./QuanLyMatKhauNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports